/* Noom PL — the next business days, counted from the calendar date in Europe/Warsaw.
   Excludes weekends and Polish statutory holidays. No dispatch cutoff or browser-local calendar arithmetic.
   Data: days-min/max (default 1/2), timezone (Europe/Warsaw), locale (pl-PL).
   Holiday list: DU 2025 poz. 296; Christmas Eve is statutory from 2025. No employer-specific substitute days. */
(function () {
  'use strict';
  var Elora = (window.Elora = window.Elora || {});
  if (Elora.etaWindow) return;
  var holidays = {};
  var fixed = ['01-01', '01-06', '05-01', '05-03', '08-15', '11-01', '11-11', '12-25', '12-26'];

  function key(date) { return date.toISOString().slice(0, 10); }
  function nextDay(date) { date.setUTCDate(date.getUTCDate() + 1); }

  function calendarDate(now, timeZone) {
    var values = {};
    new Intl.DateTimeFormat('en-CA', {
      timeZone: timeZone, calendar: 'gregory', numberingSystem: 'latn', year: 'numeric', month: '2-digit', day: '2-digit'
    }).formatToParts(now).forEach(function (part) { values[part.type] = part.value; });
    return new Date(Date.UTC(Number(values.year), Number(values.month) - 1, Number(values.day)));
  }

  function easter(year) {
    // Gregorian computus; all returned dates are calendar markers at UTC midnight.
    var a = year % 19, b = Math.floor(year / 100), c = year % 100;
    var d = Math.floor(b / 4), e = b % 4, f = Math.floor((b + 8) / 25);
    var g = Math.floor((b - f + 1) / 3), h = (19 * a + b - d - g + 15) % 30;
    var i = Math.floor(c / 4), k = c % 4, l = (32 + 2 * e + 2 * i - h - k) % 7;
    var m = Math.floor((a + 11 * h + 22 * l) / 451), n = h + l - 7 * m + 114;
    return new Date(Date.UTC(year, Math.floor(n / 31) - 1, n % 31 + 1));
  }

  function holidayDates(year) {
    if (holidays[year]) return holidays[year];
    var dates = {};
    fixed.forEach(function (day) { dates[year + '-' + day] = true; });
    if (year >= 2025) dates[year + '-12-24'] = true;
    var sunday = easter(year);
    [1, 60].forEach(function (offset) {
      var date = new Date(sunday.getTime());
      date.setUTCDate(date.getUTCDate() + offset);
      dates[key(date)] = true; // Easter Monday and Corpus Christi; Sunday holidays are excluded as weekends.
    });
    holidays[year] = dates;
    return dates;
  }

  function businessDay(date) {
    var weekday = date.getUTCDay();
    return weekday !== 0 && weekday !== 6 && !holidayDates(date.getUTCFullYear())[key(date)];
  }

  function dayCount(value, fallback) {
    var number = Number(value);
    return Number.isInteger(number) && number > 0 && number <= 366 ? number : fallback;
  }

  function deliveryWindow(now, options) {
    options = options || {};
    var min = dayCount(options.daysMin, 1);
    var max = Math.max(min, dayCount(options.daysMax, 2));
    var date = calendarDate(now, options.timeZone || 'Europe/Warsaw');
    var start, end, count = 0;
    while (count < max) {
      nextDay(date);
      if (!businessDay(date)) continue;
      count += 1;
      if (count === min) start = new Date(date.getTime());
      if (count === max) end = new Date(date.getTime());
    }
    var fields = { day: 'numeric', month: 'long', timeZone: 'UTC' };
    if (start.getUTCFullYear() !== end.getUTCFullYear()) fields.year = 'numeric';
    var formatter = new Intl.DateTimeFormat(options.locale || 'pl-PL', fields);
    var text = formatter.format(start);
    if (min !== max) {
      text = typeof formatter.formatRange === 'function' ? formatter.formatRange(start, end) : text + ' – ' + formatter.format(end);
    }
    return { start: key(start), end: key(end), text: text.replace(/\s+/g, ' ') };
  }

  function fill(el) {
    var value = el.querySelector('[data-eta-value]');
    if (!value) return;
    try {
      var result = deliveryWindow(new Date(), {
        daysMin: el.getAttribute('data-days-min'), daysMax: el.getAttribute('data-days-max'),
        timeZone: el.getAttribute('data-timezone'), locale: el.getAttribute('data-locale')
      });
      value.textContent = result.text;
      el.setAttribute('data-eta-start', result.start);
      el.setAttribute('data-eta-end', result.end);
      el.removeAttribute('data-eta-pending');
    } catch (error) {
      // Keep the readable server-rendered fallback if Intl, its locale or time zone is unavailable.
    }
  }

  function init(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    if (root.matches && root.matches('[data-elora-eta]')) fill(root);
    var els = root.querySelectorAll('[data-elora-eta]');
    for (var i = 0; i < els.length; i += 1) fill(els[i]);
  }
  Elora.etaWindow = deliveryWindow; // Pure calculation for local QA; start/end are ISO calendar dates.
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'visible') init(); });
  window.addEventListener('pageshow', function () { init(); });
})();
